import { Serializer } from '@lib/store';
import { servicingCommonInitialState } from './servicing-common.reducer';
import { ServicingCommonState } from './servicing-common.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const servicingCommonStorageDeserializer = (rawObject: any) => {
  return {
    ...servicingCommonInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as ServicingCommonState;
};

export const servicingCommonStorageSync: Serializer<ServicingCommonState> = {
  deserialize: servicingCommonStorageDeserializer,
};
